import React from 'react';
import { Link } from 'react-router-dom';
import HomeHero from './HomeHero';
import HomeSection from './HomeSection';
import HomeFeatured from './sections/HomeFeatured';
import HomeServices from './sections/HomeServices';
import HomeProjects from './sections/HomeProjects';
import HomeSignage from './sections/HomeSignage';
import HomeClients from './sections/HomeClients';
import './Home.css';

const SectionLink = ({ to, children }) => (
  <Link to={to} className="home-section__link">
    {children}
    <i className="fa-solid fa-arrow-right" aria-hidden="true" />
  </Link>
);

const Home = () => (
  <main className="home-page">
    <HomeHero />

    <HomeSection
      id="expertise"
      eyebrow="What we do"
      title="Road safety expertise across Laos"
      description="From traffic signals to road markings, we deliver reliable infrastructure that keeps people safe."
    >
      <HomeFeatured />
    </HomeSection>

    <HomeSection
      id="services"
      eyebrow="Services"
      title="Solutions built for every road"
      description="Professional road paint, signage, and safety systems tailored to public and private projects."
      action={<SectionLink to="/solutions">View all services</SectionLink>}
    >
      <HomeServices />
    </HomeSection>

    <HomeSection
      id="projects"
      eyebrow="Projects"
      title="Latest work on the ground"
      description="Recent deployments across highways, cities, and industrial sites throughout Laos."
      action={<SectionLink to="/projects">View all projects</SectionLink>}
    >
      <HomeProjects />
    </HomeSection>

    <HomeSection
      id="signage"
      eyebrow="Safety signage"
      title="Durable signs for every environment"
      description="Engineered aluminum signage with long-term visibility for highways, workplaces, and urban roads."
      action={<SectionLink to="/solutions">Learn more</SectionLink>}
    >
      <HomeSignage />
    </HomeSection>

    <HomeSection
      id="clients"
      eyebrow="Trusted by"
      title="Our clients"
      description="Partnering with public agencies and businesses across Laos."
      fullBleed
    >
      <HomeClients />
    </HomeSection>
  </main>
);

export default Home;
